export const track = (event, data) => {
  data.event = event;
  window.dataLayer.push(data);
}

export const trackError = (error) => {
  const data = {event:'formError', error:error};
  window.dataLayer.push(data);
}
